import {
  drawerWidth,
  transition,
  container
} from "../../../../assets/jss/material-dashboard-react.js";
import ImageFondo from "../../../img/portadasms.jpg";

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    backgroundImage: `url(${ImageFondo})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    // overflowScrolling: "touch"s
  },
  content: {
    marginTop: "70px",
    padding: "10px 15px",
    minHeight: "calc(100vh - 153px)",
  },
  container,
  map: {
    marginTop: "70px"
  }
});

export default appStyle;
